import { render } from "./base-button.vue?vue&type=template&id=2a15c6d4"
import script from "./base-button.vue?vue&type=script&lang=js"
export * from "./base-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__